var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('router-view'),(_vm.showMenu)?_c('Menu',{on:{"playAudio":_vm.playAudio}}):_vm._e(),_c('AudioPlayer',{ref:"audioplayer",attrs:{"queue":_vm.audioQueue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }